<template>
  <div class="bg-medium pt-0" aria-hidden="true" tabindex="-1">
    <details
      aria-hidden="true"
      tabindex="-1"
      id="copyright"
      class="dbc-gl-section bg-medium pt-0 w-full group"
      :open="isCopyrightsOpen"
      @toggle="onToggle"
    >
      <summary
        aria-hidden="true"
        tabindex="-1"
        class="cursor-pointer font-bold mb-[1rem] list-none flex items-center gap-4"
      >
        <DbcSvg
          name="dbc-icon-chevron-down"
          class="duration-300 group-open:-rotate-180"
        />
        {{ $t('dbc-text-copyright') }}
      </summary>
      <div class="pl-8" aria-hidden="true" tabindex="-1">
        <span v-for="(copyright, index) in copyrights">
          <span v-if="index !== 0">|</span> <b>{{ index + 1 }}</b>
          {{ copyright }} {{}}
        </span>
      </div>
    </details>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  copyrights?: string[]
}>()

const isCopyrightsOpen = useState('dbc-is-copyrights-open', () => false)

function onToggle(event: ToggleEvent) {
  const target = event.target as HTMLDetailsElement
  isCopyrightsOpen.value = target.open
}
</script>
